import * as _ from "lodash";
import { AssetInput, LookupAsset } from "../graphql/generated/schema-types";
import { DeepCopy } from "../helpers/object-helpers";
import { AssetInputStub } from "./object-stubs/AssetInput";

export function assetInputMapper(asset: LookupAsset) {
  const _asset = DeepCopy(asset);
  return _.pick(_asset, _.keys(new AssetInputStub())) as AssetInput;
}
